import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { EmptyState, Table } from 'shared/ui'
import { NoResultsFound } from 'shared/ui/NoResultsFound/NoResultsFound'
import { ContactStatisticBulkActions } from 'widgets/ContactStatistic'
import { useClickToTextDetailsContext } from 'pages/clickToText/pages/viewClickToText/context'
import styles from './styles.module.scss'
import { getColumns } from './getColumns'

export const ClickToTextStatisticsTableLeads = observer(() => {
  const {
    statisticsLeadsItems,
    isNoLeadsData,
    total,
    isStatisticsLeadsLoading,
    onPaginationTableChange,
    page,
    limit,
    contactStatisticsTableStore,
    search,
    onSuccessDelete,
    contactsTagsModalStore,
    onOpenContactsDetails,
  } = useClickToTextDetailsContext()
  const columns = useMemo(() => getColumns(onOpenContactsDetails), [onOpenContactsDetails])

  const selectedContactIds = useMemo(() => {
    return contactStatisticsTableStore.selectedRows.map((row) => row.contact.id)
  }, [contactStatisticsTableStore.selectedRows])

  if (isNoLeadsData) {
    return (
      <EmptyState text={'No contacts found'} noIcon boxProps={{ flexGrow: 1, height: undefined }} />
    )
  }

  if (!isStatisticsLeadsLoading && !statisticsLeadsItems.length) {
    return <NoResultsFound boxProps={{ flexGrow: 1, height: undefined }} />
  }

  return (
    <div className={styles.wrapTable}>
      <Table
        ariaLabel={'ClickToTextStatisticsTableLeads'}
        columns={columns}
        rows={statisticsLeadsItems}
        rowsCount={total}
        pinnedColumnNames={['name']}
        isLoading={isStatisticsLeadsLoading}
        onChangePagination={onPaginationTableChange}
        initPage={page}
        limit={limit}
        startPaginationSize={10}
        sxTable={{ marginRight: 2, width: 'calc(100% - 16px)' }}
        withCheckbox
        store={contactStatisticsTableStore}
        virtualization
        headerLeftContentProps={{
          actionsContent: (
            <ContactStatisticBulkActions
              search={search}
              selectedContactIds={selectedContactIds}
              onSuccessDelete={onSuccessDelete}
              withNewActions
              contactsTagsModalStore={contactsTagsModalStore}
            />
          ),
        }}
      />
    </div>
  )
})
